import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserProfileComponent as SharedUserProfileComponent } from '@sandbox-platform/shared-ui';

@Component({
  standalone: true,
  imports: [SharedUserProfileComponent],
  selector: 'app-user-profile',
  template:
    '<sb-user-profile [hideCloseButton]="false" (closeClick)="closeProfile()" />',
})
export class UserProfileComponent {
  private readonly router = inject(Router);

  closeProfile(): void {
    const returnUrl = history.state?.returnUrl;

    if (
      typeof returnUrl === 'string' &&
      returnUrl &&
      returnUrl.split(/[?#]/)[0] !== '/profile'
    ) {
      this.router.navigateByUrl(returnUrl);
      return;
    }

    this.router.navigate(['/dashboard']);
  }
}
